<template>
    <nav class="menu" v-if="sideBar">
        <profile :profileModal="profileModal"
        :walletId="connectedAccount"
        @disconnect='disconnect'
        @profileModal="closeProfileModal"></profile>
        <transition-group name="fade" tag="ul">
            <li key="logo" @click="closeSideBar()" class="side-bar-item">
                <router-link :to="{name: 'farm'}">
                    <img class="img-screen-change" src="../assets/images/logo-component-1.webp" alt="">
                </router-link>
            </li>
            <li key="1" @click="closeSideBar()" class="side-bar-item" style="margin-top:20px">
                <router-link  :to="{name: 'farm'}">Farm</router-link>
            </li>
            <li key="2" @click="closeSideBar()" class="side-bar-item">
                <router-link  :to="{name: 'games'}">Games</router-link>
            </li>
            <li key="3" @click="closeSideBar()" class="side-bar-item">
                <router-link  :to="{name: 'minting'}">Minting</router-link>
            </li>
            <li key="4" @click="closeSideBar()" class="side-bar-item">
                <router-link  :to="{name: 'whitepaper'}">Whitepaper</router-link>
            </li>
            <li key="5" @click="closeSideBar()" class="side-bar-item">
                <router-link  :to="{name: 'gamedata'}">Game Data</router-link>
            </li>
            <li class="side-bar-item connect-button" key="6">
                <button v-if="connected" @click="profileModal = true" class="connect-wallet">
                    <span>{{connectedAccount.slice(0,4)}}...{{connectedAccount.slice(connectedAccount.length - 4,connectedAccount.length)}} </span>
                </button>
                <button v-else @click="connect" class="connect-wallet">
                    connect wallet
                </button>
            </li>
            <li class="side-bar-item" key="7">
                <div class="eggs-token-quantity" style="margin-right:15px">
                <img src="../assets/images/eggtoken-2.webp" alt="">
                {{showEggBalance}}
            </div>
            </li>
            <li class="side-bar-item outsider-items" key="8">
                <a href="https://twitter.com" class="mx-2" target="_blank">
                    <img src="../assets/images/opensea.webp" alt="">
                </a>
                <a href="https://discord.gg/eggsgame" target="_blank">
                    <img src="../assets/images/discord.webp" alt="">
                </a>
                <a href="https://twitter.com/eggsgamenft" class="mx-2" target="_blank">
                    <img src="../assets/images/twtr.webp" alt="">
                </a>
            </li>
        </transition-group>
    </nav>
</template>
<script>
import Profile from './Profile.vue'
export default {
    components: { Profile },
    name:'mobile-sidebar',
    props:{
        sideBar:{
            default: false,
            type: Boolean
        },
        connectedAccount: {
            default: null,
            type: String
        },
        connected:{
            default: false,
            type: Boolean
        },
        eggsBalance:{
            default: "0",
            type: String
        }
    },
    data(){
        return{
            profileModal:false
        }
    },
    computed:{
        showEggBalance(){
            return parseFloat(this.eggsBalance).toFixed(2)
        }
    },
    methods:{
        closeSideBar(){
            this.$emit('openSidebar' , false)
        },
        connect(){
            this.closeSideBar()
            this.$emit('connect' , true)
        },
        disconnect(){
            this.closeSideBar()
            this.$emit('disconnect' , true)
        },
        closeProfileModal(value){
            this.profileModal = value
        },
    }
}
</script>
<style scoped>
.menu transition-group {
    list-style-type: none;
}
.side-bar-item a {
  font-weight: normal;
  color: #fff;
  text-decoration: none;
}
.side-bar-item a.router-link-exact-active {
  color: #ffe371;
  text-decoration: none;
}
.menu{
    left: 0;
    top: 0;
    position: fixed;
    z-index: 5;
    padding: 33px 0 0 0;
    width: calc(100% - 60px);
    height: 100%;
    background-color: #040B13;
    animation: left-to-right .5s ease-in;
}
.menu ul{
    height:90vh;
    position:relative
}
.outsider-items{
    position: absolute;
    bottom: 20px;
    width: 268px;
}
.eggs-token-quantity{
    position:absolute;
    bottom: 80px;
    background: none;
    border: 2px solid #ffcc20;;
    padding: 3px 15px;
    border-radius: 18px;
    margin-top: 3px;
    font-size: 26px;
    color: #ffcc20;
    min-width: 200px;
    text-align: center;
}
.connect-button{
    position: absolute;
    bottom: 125px;
}
.connect-wallet{
    background: none;
    border: 2px solid white;
    padding: 5px 15px;
    border-radius: 18px;
    font-size: 25px;
    color: white;
    margin: 25px 30px 20px 0;
    min-width: 200px;
}
@keyframes left-to-right {
    from {
        left:calc(110px - 100%);
        transition: ease-in .5s;
    }
    to{
        left:0
    }
}
.side-bar-item{
    list-style-type: none;
    color: white;
    font-size: 35px;
    margin-top:0px
}
@media (max-width: 368px) {
    .side-bar-item{
        font-size: 25px
    }
    .img-screen-change{
        width: 150px;
    }
    .connect-wallet{
        font-size: 17px;
    }
}
</style>